/* eslint-disable no-nested-ternary */
import { useLocation, Navigate, Outlet } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const RequireAdmin = () => {
  const { auth } = useAuth();
  const location = useLocation();

  return auth?.roles.includes('admin') ? (
    <Outlet />
  ) : auth?.accessToken ? (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireAdmin;
